export default __webpack_public_path__ + "static/media/golem-round-icon.ba52b471.svg";